import { FILTER_KEYNAME } from "@/common/consts";
import { readLocalStorage, writeLocalStorage } from "./localStorageUtils";

export const writeFilter = (filter) => {
	writeLocalStorage(FILTER_KEYNAME, filter);
};

export const readFilter = () => {
	const stub = [{ bonuspoints: false }];
	return navigator.cookieEnabled ? readLocalStorage(FILTER_KEYNAME) : stub;
};
